import { AHText, Box } from "arkh";
import { View } from "react-native";
import { OrgSelector } from "../../OrgHome/OrgSelector/Selector";
import * as Select from "@radix-ui/react-select";
import { useMemo } from "react";
import { useIntl } from "react-intl";

export function RoutineEditMainSectionSelectableSelect(props: {
  canBeDisabled: boolean;
  disabledSelector?: boolean | null;
  onValueChange: (v: boolean) => void;
}) {
  const intl = useIntl();
  const options = useMemo(() => {
    return [
      {
        id: "CAN_NOT_BE_DISABLED",
        name: intl.formatMessage({
          defaultMessage: "Required",
          description: "RoutineEditMainSectionSelectableSelect: required task",
        }),
      },
      {
        id: "CAN_BE_DISABLED",
        name: intl.formatMessage({
          defaultMessage: "Can be disabled",
          description:
            "RoutineEditMainSectionSelectableSelect: can be disabled task",
        }),
      },
    ];
  }, [intl]);

  const selectedOption = useMemo(() => {
    return options.find(
      (t) =>
        t.id ===
        (props.canBeDisabled ? "CAN_BE_DISABLED" : "CAN_NOT_BE_DISABLED")
    );
  }, [props.canBeDisabled, options]);
  return (
    <View style={{ minWidth: 120 }}>
      <OrgSelector
        disabled={!!props.disabledSelector}
        options={options.map((t) => t.id)}
        selectedValue={
          props.canBeDisabled ? "CAN_BE_DISABLED" : "CAN_NOT_BE_DISABLED"
        }
        onValueChange={(v) => {
          props.onValueChange(v === "CAN_BE_DISABLED");
        }}
        renderValue={(v) => (
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",

              flex: 1,
            }}
          >
            <AHText
              spaceRight="small"
              style={{ flex: 1 }}
              color={"text-primary"}
            >
              {selectedOption?.name ?? ""}
            </AHText>
          </Box>
        )}
        renderOption={(v) => {
          const p = options.find((t) => t.id === v);
          if (!p) {
            return null;
          }
          return (
            <Box style={{ flex: 1 }}>
              <Box
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                <Select.ItemText>
                  <AHText color="darkerText" spaceRight="large">
                    {p.name}
                  </AHText>
                </Select.ItemText>
              </Box>
            </Box>
          );
        }}
      />
    </View>
  );
}
